import "./image.css";
import { Image } from './image';
export default Image;